import { Component, OnInit } from '@angular/core';
import { Http } from "@angular/http";
import { Router }  from '@angular/router';
import { Member } from '../member/member';
import { MemberService } from '../member/member.service';
import * as firebase from 'firebase';

@Component({
  selector: 'cef-memberList',
  templateUrl: './assign.component.html'
})

export class AssignComponent implements OnInit {
	public assignedArr: any[] = [];
	public assignableArr: any[] = [];
	public unAssignArr: any[] = [];
	public childToParent:any;
	public currUser;
	public currUserProfile;
	public currTab = 0;
	public db;
	public selectableMember:any[] = [];
	public allMemberProfile: any[] = [];
	public currSelectedUid
	public msg = '';

	constructor(private http: Http, private router: Router, private memberService: MemberService) {
		
	}

	ngOnInit(): void {
		this.db = firebase.database();

		firebase.auth().onAuthStateChanged((user:any) => {
		  if (user) {
		    this.currUser = user;
		    this.db.ref('profile/').once('value').then(
		    	(snapshot:any) => {
		    		if (snapshot.val()){
		    			this.allMemberProfile = snapshot.val();
		    			for (let uid in this.allMemberProfile){
		    				if (uid == this.currUser.uid){
								this.currUserProfile = this.allMemberProfile[uid];
								this.selectTab(this.currUserProfile.level);
		    					break;
		    				}
		    			}
		    		}
		    	}
		    )
		  }
		});
    }

    selectTab(tabNum:number){
    	this.currTab = tabNum;
    	this.selectableMember = [];
		this.unAssignArr = [];
		
		var passLvl = tabNum*1 + 1;
		for (let uid in this.allMemberProfile){
			//if (this.allMemberProfile[uid].level == (tabNum + 1)){
			if (this.allMemberProfile[uid].level == passLvl){
				if (this.currUserProfile.level<2){//webadmin, admin
					this.selectableMember.push({
						uid:uid,
						unit:this.allMemberProfile[uid].unit,
						name:this.allMemberProfile[uid].name
					});
				} else if (this.currUserProfile.level==2){//subadmin
					if (this.currUserProfile.unit==this.allMemberProfile[uid].unit){
						this.selectableMember.push({
							uid:uid,
							unit:this.allMemberProfile[uid].unit,
							name:this.allMemberProfile[uid].name
						});
					}
				}
				
			}
		}

		this.selectableMember.sort(this.sortSelectable);
		this.assignedArr = [];
		this.assignableArr = [];
    }

	sortSelectable(a,b) {
		if (a.unit < b.unit) return -1;
		if (a.unit > b.unit) return 1;
		return 0;
	}

    selectMember(uid:string){
    	this.currSelectedUid = uid;
    	this.assignedArr = [];
		this.assignableArr = [];
		this.unAssignArr = [];
		//find assigned member on current level
		this.db.ref('parentToChild/'+uid).once('value').then(
			(snapshot:any) => {
	    		if (snapshot.val() != null){
	    			//find assigned member and push onto assignedArr
	    			for (var assigned of snapshot.val()){
	    				this.assignedArr.push({
	    					uid:assigned,
	    					name:this.allMemberProfile[assigned].name,
	    					unit:this.allMemberProfile[assigned].unit
	    				})
	    			}
	    		}
	    		this.findAssigable(uid);
	    	}
	    );
    }

    findAssigable(selUid){
    	this.db.ref('childToParent/'+(this.currTab+2)+'/').once('value').then(
	    	(snapshot:any) => {
	    		this.childToParent = snapshot.val();
	    		for (let uid in this.allMemberProfile){
		    		if (this.childToParent) if (this.childToParent[uid] !== undefined) continue;
					if (this.allMemberProfile[uid].level == this.currTab + 2){
						if (this.currTab>=1){
							//select only same unit
							if (this.allMemberProfile[uid].unit == this.allMemberProfile[selUid].unit){
								this.assignableArr.push({
									uid:uid,
									name:this.allMemberProfile[uid].name,
									unit:this.allMemberProfile[uid].unit
								})
							}
						} else {
							this.assignableArr.push({
								uid:uid,
								name:this.allMemberProfile[uid].name,
								unit:this.allMemberProfile[uid].unit
							})
						}
					}
				}
				this.assignableArr.sort(this.sortSelectable);
	    	}
	    )
    	
    }

    saveAssign(){
    	//save assignedArr to parentToChild
		var saveArr = [];
		for (let uid in this.assignedArr){
			saveArr.push(this.assignedArr[uid].uid);
		}
		
		this.db.ref('parentToChild/' + this.currSelectedUid).set(saveArr).then(
			()=>{
				for (let assignedUid in this.assignedArr){
    				this.db.ref('childToParent/'+(this.currTab+2)+'/'+this.assignedArr[assignedUid].uid).set(this.currSelectedUid);
    			}
    			//handle unassigned
				for(let unassignedUid of this.unAssignArr){
					this.db.ref('childToParent/'+(this.currTab+2)+'/'+unassignedUid).remove();
				}
    			this.msg = '配對已儲存！';
    			setTimeout(()=>{this.msg = '';},this.memberService.modalDismiss);
			}
		).catch(
			(error:any)=>{console.log(error);}
		);
    	
    }

    assignMember(uid){
    	this.assignedArr.push({
			uid:uid,
			name:this.allMemberProfile[uid].name,
			unit:this.allMemberProfile[uid].unit
		})
    	this.assignedArr.sort(this.sortSelectable);

		for (var index in this.assignableArr){
			if (this.assignableArr[index].uid == uid){
				this.assignableArr.splice(parseInt(index),1);
				break;
			}
		}
		if (this.unAssignArr.indexOf(uid) != -1) this.unAssignArr.splice(this.unAssignArr.indexOf(uid), 1);
    }

    unAssignMember(uid){
    	this.assignableArr.push({
			uid:uid,
			name:this.allMemberProfile[uid].name,
			unit:this.allMemberProfile[uid].unit
		})
		this.assignableArr.sort(this.sortSelectable);

		for (var index in this.assignedArr){
			if (this.assignedArr[index].uid == uid){
				this.assignedArr.splice(parseInt(index),1);
				break;
			}
		}
		this.unAssignArr.push(uid);
		this.assignedArr.sort(this.sortSelectable);
    }
 
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/webadmin/assign.component.ts